import type { SrOrderStatus, SrSalesOrderType } from '@plato/data/starrocks/types';
import { cn } from '@plato/ui/util/classes';
import type { ComponentPropsWithRef, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { getOrderStatusColor, getOrderStatusLabel, type StatusColor } from '../utils/order-status.ts';

type Props = ComponentPropsWithRef<'span'> & {
    status: SrOrderStatus;
    type: SrSalesOrderType;
};

export function OrderStatusDot({ status, type, className, ...props }: Props): ReactElement {
    const { t } = useTranslation('order-status');

    return (
        <span className={cn('flex shrink-0 items-center gap-tight', className)} {...props}>
            <span
                aria-hidden
                className={cn(
                    'size-1.5 shrink-0 rounded-full',
                    getDotClassName(getOrderStatusColor(type, status)),
                )}
            />
            <span className="whitespace-nowrap text-caption text-content-weaker">
                {getOrderStatusLabel(t, status)}
            </span>
        </span>
    );
}

function getDotClassName(color: StatusColor): string {
    switch (color) {
        case 'green':
            return 'bg-green-500';
        case 'red':
            return 'bg-red-500';
        case 'yellow':
            return 'bg-amber-400';
        case 'orange':
            return 'bg-orange-500';
        case 'blue':
            return 'bg-teal-500';
        case 'neutral':
            return 'bg-neutral-400';
    }
}
